import { cn } from "@/lib/utils";
import type { HttpMethod } from "@/lib/docs/api";

const COLORS: Record<HttpMethod, string> = {
  GET: "bg-[#EEF3FF] text-[#335CFF]",
  POST: "bg-[#E9F8EF] text-[#1B7F4B]",
  PATCH: "bg-[#FFF4E5] text-[#B45309]",
  DELETE: "bg-[#FDECEC] text-[#B42318]",
};

const MethodBadge = ({ method, className }: { method: HttpMethod; className?: string }) => (
  <span
    className={cn(
      "inline-flex shrink-0 items-center rounded-md px-2 py-0.5 font-mono text-[11px] font-semibold tracking-wide",
      COLORS[method],
      className,
    )}
  >
    {method}
  </span>
);

export default MethodBadge;
